<template>
  <ul class="list-none">
    <li
      class="flex items-center py-0.5 gap-3 lg:hidden hover:bg-EXPONDO-grey-5"
    >
      <AllCategoriesIndicator />
      <NavigationLink
        class="flex-1 text-base text-EXPONDO-grey"
        v-bind="shopAllProductsProps"
      />
    </li>
    <li
      class="max-lg:hidden mb-1 py-1 hover:bg-EXPONDO-grey-5 cursor-pointer flex items-center gap-3"
      @click="itemClick('')"
    >
      <AllCategoriesIndicator />
      <span
        class="flex-1 font-normal text-EXPONDO-grey cursor-pointer"
      >
        {{ shopAllProductsProps.text }}
      </span>
    </li>
    <li
      v-for="category in firstLevelCategories"
      :key="category.id || category.slug"
      class="flex mb-1 py-0.5 items-center text-base cursor-pointer hover:bg-EXPONDO-grey-5 rounded-sm"
      @click="itemClick(category.slug)"
    >
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-3">
          <div class="inline-block w-7 text-EXPONDO-primary">
            <ImgView
              :src="getCategoryIcon(category.key) || DEFAULT_CATEGORY_ICON"
              :default-src="DEFAULT_CATEGORY_ICON"
              class="inline"
            />
          </div>
          <span class="flex-1 font-normal text-EXPONDO-grey">
            {{ category.name }}
          </span>
        </div>
        <span
          class="iconify svg--chevron-right text-lg transform text-EXPONDO-grey"
        />
      </div>
    </li>
    <li>
      <NavigationLink
        class="text-EXPONDO-black"
        v-bind="bestSellersLinkProps"
      />
    </li>
    <li>
      <NavigationLink
        class="text-EXPONDO-red"
        v-bind="onSaleButtonProps"
      />
    </li>
  </ul>
</template>

<script lang="ts">

import type { Category } from '~~/types/commercetools';
import getCategoryIcon from '~~/helpers/category/getCategoryIcon';
import { createBestsellingLink, createOnSaleLink } from '~~/helpers/navigation/createNavLinks';

import { ROUTES_INFORMATION, ROUTES } from '~~/constants/routes';

export default defineComponent({
  name: 'NavSidebarCategoriesList',

  props: {
    firstLevelCategories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
  },
  setup() {

    const i18n = useI18n();
    const { setFirstLevelCategory } = useNavigationState();
    const categoryOnSaleLink = createOnSaleLink();
    const bestsellersLink = createBestsellingLink();
    const shortcutLinkStyles = 'mt-2 block text-base font-bold cursor-pointer py-0.5 hover:bg-EXPONDO-grey-5';
    const onSaleButtonProps = {
      text: i18n.t('on-sale'),
      url: categoryOnSaleLink,
      class: shortcutLinkStyles,
    };
    const bestSellersLinkProps = {
      text: i18n.t('bestseller'),
      url: bestsellersLink,
      class: shortcutLinkStyles,
    };

    const itemClick = (slug: string) => {

      setFirstLevelCategory(slug);
    
    };

    const shopAllProductsProps = {
      text: i18n.t('all-products'),
      url: ROUTES_INFORMATION[ROUTES.SEARCH].SLUG,
    };

    return {
      getCategoryIcon,
      itemClick,
      onSaleButtonProps,
      shopAllProductsProps,
      bestSellersLinkProps,
      DEFAULT_CATEGORY_ICON: '/icons/categories/category.svg',
    };
  
  },
});

</script>
